export default "__VITE_ASSET__53ba7ff0__"